import styled from 'styled-components';

interface IWrapper {
  margin?: string;
}

export const Wrapper = styled.div<IWrapper>`
  display: flex;
  margin: ${(props) => (props.margin ? props.margin : 0)};
  align-items: center;
  gap: 14px;
  grid-column: span 2;

  @media only screen and (max-width: 500px) {
    grid-column: unset;
  }
`;

export const BackButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #74c598;
  background-color: #74c598;

  & svg {
    font-size: 18px;
    color: #fff;
  }
`;

interface IContainer {
  weight?: string;
  line?: string;
}

export const Container = styled.p<IContainer>`
  font-size: 24px;
  color: #42434a;
  margin: 0;
  font-weight: ${(props) => (props.weight ? props.weight : 'bold')};
  line-height: ${(props) => (props.line ? props.line : 'normal')};
`;
